<template>
  <el-dialog
    :title="selType == 1 ? '巡查人' : '选择巡查人'"
    :visible.sync="dialogVisible"
    :modal-append-to-body="false"
    :append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
    :before-close="handleClose"
  >
    <div>
      <div class="select" v-if="selType == 0">
        <el-cascader
          :options="departmentHead"
          :props="{ multiple: true, emitPath: false }"
          v-model="selectPeople"
          @change="selectDepartmentHead"
          ref="departmentHeadSelect"
          size="mini"
          filterable
          clearable
          placeholder="请选择巡查人"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.label }}</span>
            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
          </template>
        </el-cascader>
      </div>
      <div v-if="selType == 1">
        <div>
          <el-button type="primary" plain @click="selEdit" size="mini"
            >编辑</el-button
          >
          <el-button
            type="danger"
            plain
            @click="del"
            size="mini"
            :disabled="userList.length == 0"
            >删除</el-button
          >
        </div>
        <div class="info">
          <div class="name">巡查人员:</div>
          <div class="list">
            <template v-if="userList.length > 0">
              <span class="li" v-for="(item, index) in userList" :key="index">
                {{ item.userName }} <span>，</span>
              </span>
            </template>
            <span v-else>暂无巡查人员</span>
          </div>
        </div>
      </div>
      <!-- <el-cascader
        ref="cascaderOneRef"
        @change="selectGroupMember"
        @remove-tag="removeTagMember"
        placeholder="请选择巡查人"
        :options="teamMemberList"
        v-model="teamMemberValue"
        :props="{ multiple: true, value: 'id', label: 'label' }"
        filterable
        collapse-tags
      >
        <template slot-scope="{ node, data }">
          <span>{{ data.label }}</span>
          <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
        </template>
      </el-cascader> -->
    </div>
    <span slot="footer" class="dialog-footer">
      <template v-if="selType == 0">
        <el-button @click="selType = 1" size="small">返回</el-button>
        <el-button type="primary" @click="edit" size="small">确定</el-button>
      </template>
      <template v-if="selType == 1">
        <el-button @click="cancel" size="small">关闭</el-button>
      </template>
    </span>
  </el-dialog>
</template>

<script>
import DailyPatrol from "@/components/DailyPatrol";
export default {
  name: "",
  components: { DailyPatrol },
  props: {
    selectId: {
      type: Number,
      default: {
        return: 0
      }
    },
    resize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      userIds: [],
      userList: [],
      selType: 1,
      selectPeople: [],

      teamMemberValue: [], //当前选择的组长
      teamLeaderValue: [], //当前选择的后勤人员
      teamMemberList: [], //组长数组

      // 部门负责人
      departmentHead: [],
      testUserInfo: {
        userId: ""
      },
      testUserInfo1: {
        userId: ""
      }
    };
  },
  created() {},
  watch: {
    resize: function(newVal, oldVal) {
      if (newVal) {
        this.getPeople();
        this.dialogVisible = true;
      }
    }
  },
  computed: {},
  methods: {
    cancel() {
      this.handleClose();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.selType = 1;
    },
    selEdit() {
      this.selType = 0;
      this.getDepartmentHead();
    },

    // 选择负责人(新增任务时使用)
    selectDepartmentHead(data) {
      // console.log(this.selectPeople)
      // console.log(data);
      // console.log(node)
      var newData = this.$refs.departmentHeadSelect.getCheckedNodes();
      let newList = newData.filter((item) => {
        return item.level == 2;
      });
      // console.log(this.$refs.departmentHeadSelect);
      // console.log(newData);
      // console.log(newList);
      this.userIds = newList.map((element) => {
        return element.data.thisId;
      });
      // if (data.length > 0) {
      //   // let value = this.$refs.departmentHeadSelect.panel.getNodeByValue(
      //   //   this.selectPeople
      //   // ).data.thisId;
      //   // console.log(value)
      //   // console.log(newData[0].data.thisId);
      //   // this.requestParam.supervisorsId = value;
      // } else {
      //   // this.requestParam.supervisorsId = "";
      // }
      // console.log(this.requestParam.userId)
      // this.requestParam.userId = newData[0].data.thisId

      // if (data.length > 0) {
      //   let value = this.$refs.departmentHeadSelect.panel.getNodeByValue(
      //     this.testUserInfo.userId
      //   ).data.thisId;
      //   // console.log(value)
      //   // console.log(newData[0].data.thisId);
      //   this.requestParam.supervisorsId = value;
      // } else {
      //   this.requestParam.supervisorsId = "";
      // }
      // console.log(this.requestParam.userId)
      // this.requestParam.userId = newData[0].data.thisId
    },

    // 获取部门及负责人
    async getDepartmentHead() {
      var _this = this;
      var paramData = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getDepartmentHead(paramData, true);
      if (res.code == 200) {
        // this.departmentHead = res.data
        // console.log(res.data)
        let data = res.data || [];
        let newTeamReporters = [];
        let list = data.map((item) => {
          let obj = {
            level: 1,
            id: item.departmentId || "",
            label: item.departmentName || "",
            children: []
          };
          newTeamReporters.push(item.departmentId);
          if (item.dlist) {
            obj.children = item.dlist.map((iitem) => {
              let objc = {
                level: 2,
                id: iitem.userId || "",
                label: iitem.userName || ""
              };
              newTeamReporters.push(iitem.userId);
              return objc;
            });
          }
          return obj;
        });

        _this.selectedPersonList = [];
        var departmentHeadList = [];

        this.selectPeople = [];
        this.userList.forEach((item, index) => {
          list.forEach((iitem, iindex) => {
            if (iitem.children) {
              iitem.children.forEach((iiitem, iiidenx) => {
                if (item.userId == iiitem.id) {
                  // console.log(item)
                  // this.selectPeople.push([iitem.id, iiitem.id]);
                  this.selectPeople.push([iindex + '-' + iiidenx]);
                  // console.log(iitem.id, iiitem.id)
                  // console.log(index, iindex)
                }
              });
            }
          });
        });




        for (var keyOne in res.data) {
          var thisUserList = [];
          for (var keyTwo in res.data[keyOne].dlist) {
            // 负责人默认选择
            // if (
            //   this.requestParam.supervisorsId ==
            //   res.data[keyOne].dlist[keyTwo].userId
            // ) {
            //   this.testUserInfo.userId = [];
            //   this.testUserInfo.userId.push(keyOne);
            //   this.testUserInfo.userId.push(keyOne + "-" + keyTwo);
            // }

            // if (
            //   this.requestParam.actualerId ==
            //   res.data[keyOne].dlist[keyTwo].userId
            // ) {
            //   this.testUserInfo1.userId = [];
            //   this.testUserInfo1.userId.push(keyOne);
            //   this.testUserInfo1.userId.push(keyOne + "-" + keyTwo);
            // }

            // 巡查人员默认选择
            // if (
            //   this.requestParam.dailyTaskTimeStatus == 1 &&
            //   this.requestParam.timeQuantumList.length >= 1
            // ) {
            //   var selectedUserInfo = Object.assign(
            //     {},
            //     this.requestParam.timeQuantumList[0]
            //   );
            //   var selectedUserList = selectedUserInfo.userIdArray
            //     ? selectedUserInfo.userIdArray.split(",")
            //     : [];
            //   selectedUserList.forEach((element) => {
            //     if (element == res.data[keyOne].dlist[keyTwo].userId) {
            //       var personUserGroup = [];
            //       personUserGroup.push(keyOne);
            //       personUserGroup.push(keyOne + "-" + keyTwo);
            //       _this.selectedPersonList.push(personUserGroup);
            //     }
            //   });
            // } else if (
            //   this.requestParam.dailyTaskTimeStatus == 0 &&
            //   this.requestParam.timeQuantumList.length >= 1
            // ) {
            //   for (var i = 0; this.inspectionPeriod.length > i; i++) {
            //     var selectedUserList = this.inspectionPeriod[i].userIdArray
            //       ? this.inspectionPeriod[i].userIdArray.split(",")
            //       : [];
            //     selectedUserList.forEach((element) => {
            //       if (element == res.data[keyOne].dlist[keyTwo].userId) {
            //         var personUserGroup = [];
            //         personUserGroup.push(keyOne);
            //         personUserGroup.push(keyOne + "-" + keyTwo);
            //         this.inspectionPeriod[i].userIdString.push(personUserGroup);
            //       }
            //     });
            //   }
            // }

            var newThisData = {
              value: keyOne + "-" + keyTwo,
              label: res.data[keyOne].dlist[keyTwo].userName,
              thisId: res.data[keyOne].dlist[keyTwo].userId,
              thisLevel: 2
            };
            thisUserList.push(newThisData);
          }

          departmentHeadList[keyOne] = {
            value: keyOne,
            label: res.data[keyOne].departmentName,
            thisId: res.data[keyOne].departmentId,
            thisLevel: 1,
            children: thisUserList
          };
        }
        this.departmentHead = departmentHeadList;
        // console.log(this.inspectionPeriod)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },

    selectGroupMember(val) {
      // this.form.teamMemberList = val.map((item) => {
      //   let obj = {
      //     userId: item[1] || "",
      //   };
      //   return obj;
      // });
      this.$nextTick(() => {
        let dataList = this.$refs.cascaderOneRef.getCheckedNodes(true);
        // console.log(this.$refs.cascaderOneRef.getCheckedNodes(), "ref");
        // console.log(this.form.teamMemberList, "list");
        let newList = dataList.filter((item) => {
          return item.level == 2;
        });
        let newDataList = newList.map((item) => {
          let obj = {
            userId: item.value || "",
            userName: item.label || "",
            teamMemberResponsibilities: ""
          };
          return obj;
        });
        let self = this;
        newDataList.forEach((element, index) => {
          self.oldTeamMemberList.forEach((eelement, iindex) => {
            if (element.userId == eelement.userId) {
              element.teamMemberResponsibilities =
                eelement.teamMemberResponsibilities;
            }
          });
        });
        this.form.teamMemberList = newDataList || [];
        this.oldTeamMemberList = newDataList || [];
      });
    },
    removeTagMember(val) {
      this.form.teamMemberList = this.form.teamMemberList.filter((item) => {
        return item.userId != val[1];
      });
    },
    //获取组长-后勤人员-组员数组
    async getTeamList(index, id) {
      var params = {
        status: index,
        schoolId: parseInt(this.$store.state.schoolId),
        securityTeamId: id
      };
      this.treeLoading = true;
      let res = await this.$Http.getDepartmentHead(params, true);
      if (res.code == 200) {
        let data = res.data || [];
        let newTeamReporters = [];
        let list = data.map((item) => {
          let obj = {
            level: 1,
            id: item.departmentId || "",
            label: item.departmentName || "",
            children: []
          };
          newTeamReporters.push(item.departmentId);
          if (item.dlist) {
            obj.children = item.dlist.map((iitem) => {
              let objc = {
                level: 2,
                id: iitem.userId || "",
                label: iitem.userName || ""
              };
              newTeamReporters.push(iitem.userId);
              return objc;
            });
          }
          return obj;
        });
        if (index == 1) {
          this.teamMemberValue = [];
          this.form.teamMemberList.forEach((item) => {
            list.forEach((iitem) => {
              if (iitem.children) {
                iitem.children.forEach((iiitem) => {
                  if (item.userId == iiitem.id) {
                    this.teamMemberValue.push([iitem.id, iiitem.id]);
                    // console.log(iitem.id, iiitem.id)
                  }
                });
              }
            });
          });
          this.teamMemberList = [];
          this.teamMemberList = list;
        } else if (index == 2) {
          this.teamLeaderValue = [];
          this.form.teamLeaderList.forEach((item) => {
            list.forEach((iitem) => {
              if (iitem.children) {
                iitem.children.forEach((iiitem) => {
                  if (item.userId == iiitem.id) {
                    this.teamLeaderValue.push([iitem.id, iiitem.id]);
                  }
                });
              }
            });
          });
          this.teamLeaderList = [];
          this.teamLeaderList = list;
        } else {
          this.teamReporters = [];
          this.$refs.teamMemberTree.setCheckedKeys(newTeamReporters);
          this.teamReporters = list.map((item) => {
            item.disabled = true;
            if (item.children) {
              item.children = item.children.map((iitem) => {
                iitem.disabled = true;
                return iitem;
              });
            }
            return item;
          });
          this.treeLoading = false;
        }
      } else {
        if (index == 1) {
          this.teamMemberList = [];
        } else if (index == 2) {
          this.teamMemberList = [];
        } else {
          this.teamMemberList = [];
          this.treeLoading = false;
        }
      }
    },

    async edit() {
      if (this.userIds.length == 0) {
        this.$message({
          type: "info",
          message: "请选择巡查人！"
        });
        return;
      }
      let req = {
        userIds: this.userIds,
        targetingId: this.selectId
      };
      let res = await this.$Http.editPatrolLocationPeople(req);
      if (res.code == 200) {
        this.selType = 1;
        this.getPeople();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async getPeople() {
      let req = {
        targetingId: this.selectId
      };
      let res = await this.$Http.getPatrolLocationPeople(req);
      if (res.code == 200) {
        this.userList = res.data;
      } else if (res.code == 101) {
        this.userList = [];
        this.selectPeople = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async del() {
      let req = {
        targetingId: this.selectId
      };
      let res = await this.$Http.delPatrolLocationPeople(req);
      if (res.code == 200) {
        this.getPeople();
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.select {
  padding: 20px 0;
}
.el-cascader {
  width: 100%;
  /deep/ .el-input {
    width: 100%;
  }
}
.info {
  padding: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .name {
    min-width: 80px;
    font-size: 14px;
    font-weight: bold;
    color: #606266;
  }
  .li {
    display: inline-block;
    &:last-child {
      span {
        display: none;
      }
    }
  }
}
</style>
